import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../store'
import { selectSelf } from '..'

export const selectUserState = createSelector(selectSelf, (state: RootState) => state.user)
